import { cn } from '@/lib/utils'
import LinkWithTransition from '@/v2/components/helpers/link-with-transition'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import { Button } from '@/v2/components/ui/button'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { staggerContainer, zoomIn } from '@/v2/constants/motion'
import { CardType } from '@/v2/types/cards'
import { motion } from 'framer-motion'
import React from 'react'

interface PromotionalBannerSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  card: CardType
  ctaButton?: { href: string; text: string }
  imgClassName?: string
}

const PromotionalBannerSection: React.FC<PromotionalBannerSectionProps> = props => {
  const { card, ctaButton, className, imgClassName, ...rest } = props

  return (
    <motion.section
      variants={staggerContainer(1, 0)}
      initial='hidden'
      whileInView='show'
      viewport={{ once: true, amount: 0.25 }}
      className={cn('text-center landing-pages-wr section-container section-spacing', className)}
    >
      <SectionWrapper {...rest}>
        <motion.article
          className={cn(
            'flex items-center md-mn:gap-5 xl-min:gap-20 lg-mn:gap-12 bg-[#F9F8F8] gap-6 rounded-lg py-5 px-4 lg-mn:p-6 md-mn:flex-row flex-col xl-min:h-[381px]'
          )}
          variants={zoomIn(0, 1)}
        >
          {card.image && (
            <div>
              <ResponsiveImage
                src={card.image.src}
                alt={card.image.alt}
                className={cn('xl-min:w-[488px] xl-min:h-[245px] w-[340px] h-[171px]', imgClassName)}
                imgClassName={imgClassName}
              />
            </div>
          )}

          <div className='md-mn:text-left [&>h3]:text-heading-home [&>h3]:font-bold xl-min:[&>h3]:text-[32px] [&>h3]:text-xl [&>h3]:leading-[30px] xl-min:[&>h3]:leading-[56px]'>
            <h3>{card.title}</h3>
            <p className='text-paragraph mt-3 leading-8 text-base xl-min:text-lg xl-min:w-[70%]'>{card.description}</p>
            {ctaButton && (
              <LinkWithTransition href={ctaButton.href} className='self-center lg-mn:self-start'>
                <Button
                  variant='call_to_action'
                  className='transition-all animate-bounce hover:animated-paused mt-6 w-[197px] xl-min:h-[50px] h-11 xl-min:text-lg text-base'
                >
                  {ctaButton.text}
                </Button>
              </LinkWithTransition>
            )}
          </div>
        </motion.article>
      </SectionWrapper>
    </motion.section>
  )
}
export default PromotionalBannerSection
